// extracted by mini-css-extract-plugin
export var logo = "_l5-2";
export var logoWrapper = "_l5-1";
export var strip = "_l5-0";